import {
  CONTENT_TYPE,
  IFeatureVariationContainer,
} from 'marketing-site/@types/generated/contentful'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import React, { Fragment } from 'react'
import { Entry } from 'contentful'
import { useFeatureFlagState } from 'marketing-site/src/library/hooks/featureFlags/useFeatureFlagState'
import { FeatureFlag, FeatureFlagState } from 'marketing-site/lib/featureFlags'

export function isFeatureVariationContainer(
  entry: Entry<any>,
): entry is IFeatureVariationContainer {
  return entry.sys.contentType?.sys.id === 'featureVariationContainer'
}

export function ContentfulFeatureVariationContainer(
  featureVariationContainer: IFeatureVariationContainer,
): React.ReactElement | null {
  const { featureFlag, contentWhenEnabled, contentWhenDisabled } = featureVariationContainer.fields
  const featureFlagId = featureFlag?.fields.key as FeatureFlag
  const featureFlagState = useFeatureFlagState(featureFlagId)

  let isEnabled = false
  switch (featureFlagState) {
    case FeatureFlagState.Enabled:
      isEnabled = true
      break
    case FeatureFlagState.Disabled:
      isEnabled = false
      break
    case FeatureFlagState.Unknown:
      // Fall back to the state stored in the feature flag itself
      isEnabled = !!featureFlag.fields.enabled
  }

  const children = isEnabled ? contentWhenEnabled : contentWhenDisabled

  return (
    <>
      {children?.map((item) => (
        <React.Fragment key={item.sys.id}>
          {renderTransformedComponent(item.sys.contentType?.sys.id as CONTENT_TYPE, item)}
        </React.Fragment>
      ))}
    </>
  )
}
